import { AppError } from "../../common/erros/AppError";
import { SessionExpiredError } from "../../common/erros/SessionExpiredError";
import { ResponseCodes } from "./ResponseCodes";
import { applog } from '../../domain/utils/applog';

export function handleRemoteException(error: any): Error {

    if (error.response) {
        const body = error.response.data;
        applog('handleRemoteException',"Exception BODY", body);
        const code = body.code;
        if ((code === ResponseCodes.NO_ACTIVE_SESSION) ||
            (code === ResponseCodes.INVALID_TOKEN)
            || (code === ResponseCodes.EXPIRED_TOKEN)) {

            applog("Exception SessionExpiredError", body);
            throw new SessionExpiredError();
        } else {
            throw new AppError(body.userMessage ?? "Lo sentimos, intente más tarde");
        }
    } else if (error.request) {
        throw new AppError("Lo sentimos, no se obtuvo respuesta del servidor. Por favor, intente más tarde");
    } else {
        throw new AppError("Lo sentimos. Por favor, intente más tarde");
    }
}